import { useState, useEffect } from 'react';

interface NavbarProps {
  onOpenApprovalModal: () => void;
}

export default function Navbar({ onOpenApprovalModal }: NavbarProps) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    setMobileOpen(false);
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16 md:h-18">
        <a href="#" className="flex items-center gap-2.5 group cursor-pointer">
          <img
            src="https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/b4573abb41861ee3e1a13dce7bef25dc.jpeg"
            alt="Smart Hizmet Logo"
            className="w-9 h-9 rounded-lg object-cover"
          />
          <span className={`font-heading font-bold text-lg transition-colors duration-300 ${scrolled ? 'text-foreground-900' : 'text-background-50'}`}>
            Smart Hizmet
          </span>
        </a>

        <div className="hidden md:flex items-center gap-8">
          {[
            { label: 'Sistem', id: 'nasil-calisir' },
            { label: 'Neler Dahil', id: 'neler-dahil' },
            { label: 'Fiyat', id: 'fiyat' },
            { label: 'Senaryolar', id: 'senaryolar' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollToSection(item.id)}
              className={`text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                scrolled
                  ? 'text-foreground-600 hover:text-foreground-900'
                  : 'text-background-50/80 hover:text-background-50'
              }`}
            >
              {item.label}
            </button>
          ))}
          <button
            type="button"
            onClick={onOpenApprovalModal}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-500 text-background-50 text-sm font-semibold hover:bg-accent-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-line"></i>
            Uygundur Yaz
          </button>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
            scrolled ? 'text-foreground-800' : 'text-background-50'
          }`}
          aria-label="Menü"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70 px-4 py-4 flex flex-col gap-2">
          {[
            { label: 'Sistem', id: 'nasil-calisir' },
            { label: 'Neler Dahil', id: 'neler-dahil' },
            { label: 'Fiyat', id: 'fiyat' },
            { label: 'Senaryolar', id: 'senaryolar' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollToSection(item.id)}
              className="text-foreground-700 text-sm font-medium py-2 px-3 rounded-lg hover:bg-background-100 text-left cursor-pointer"
            >
              {item.label}
            </button>
          ))}
          <button
            type="button"
            onClick={() => {
              setMobileOpen(false);
              onOpenApprovalModal();
            }}
            className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-accent-500 text-background-50 text-sm font-semibold hover:bg-accent-600 transition-all duration-200 cursor-pointer whitespace-nowrap justify-center mt-2"
          >
            <i className="ri-whatsapp-line"></i>
            Uygundur Yaz
          </button>
        </div>
      )}
    </nav>
  );
}